/**
 * vue-router配置，
 * 最终会被展开合并进入./index.js
 */
 import Layout from '@/views/layout/index.vue'
 export default [
     {
         name: '公告',
         path: '/notice/index',
         perm: '',
         component: Layout,
         meta: {module: 'notice'},
         children: [
             {
                 name: '公告',
                 path: '/notice/index',
                 perm: '',
                 meta: {module: 'notice'},
                 show:false,
                 component: () => import('@/views/notice/index.vue'),
             },
         ],
     }
 ]